import { useFrame } from '@react-three/fiber'
import { useRef } from 'react'
import * as THREE from 'three'
import type { Combatant } from './simulation'
import { combatStatusPulse, combatStatusRotationDelta } from './combatStatusVfxMath'

export function CombatStatusVfx({ state, accent }: { state: Combatant; accent: string }) {
  const root = useRef<THREE.Group>(null)
  useFrame((frame, dt) => {
    if (!root.current) return
    root.current.rotation.y += combatStatusRotationDelta(dt, state.wakeInvuln)
    const pulse = combatStatusPulse(frame.clock.elapsedTime, state.wakeInvuln)
    root.current.scale.setScalar(pulse)
  })

  if (!state.downed && state.wakeInvuln <= 0) return null

  if (state.downed) {
    return (
      <group ref={root} position={[state.x, 0.035, 0]}>
        <mesh rotation={[-Math.PI / 2, 0, 0]}>
          <ringGeometry args={[0.72, 0.9, 28]} />
          <meshBasicMaterial color={accent} transparent opacity={0.34} blending={THREE.AdditiveBlending} depthWrite={false} />
        </mesh>
        {Array.from({ length: 5 }, (_, i) => {
          const a = (i / 5) * Math.PI * 2
          return (
            <mesh key={i} position={[Math.cos(a) * 0.72, 0.08, Math.sin(a) * 0.5]} rotation={[a * 0.5, a, 0]}>
              <tetrahedronGeometry args={[0.05, 0]} />
              <meshBasicMaterial color={i % 2 ? accent : '#ffffff'} transparent opacity={0.42} blending={THREE.AdditiveBlending} depthWrite={false} />
            </mesh>
          )
        })}
      </group>
    )
  }

  return (
    <group ref={root} position={[state.x, 1.05, 0]}>
      <mesh rotation={[Math.PI / 2, 0, 0]}>
        <torusGeometry args={[0.78, 0.022, 6, 36]} />
        <meshBasicMaterial color={accent} transparent opacity={0.62} blending={THREE.AdditiveBlending} depthWrite={false} />
      </mesh>
      <mesh>
        <sphereGeometry args={[0.7, 12, 10]} />
        <meshBasicMaterial color={accent} transparent opacity={0.09} blending={THREE.AdditiveBlending} depthWrite={false} side={THREE.DoubleSide} />
      </mesh>
    </group>
  )
}
